module.exports = __webpack_public_path__ + "static/media/hydroclima.3360f524.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/ro/hydroclima.png
// module id = 117
// module chunks = 0